import React, {FC} from 'react';
import {GoForwardIcon, LoadingSpinner, StripeIcon} from 'components';
import {selectUserProfile} from 'features/User';
import {PaymentService, ProviderProfile, SliceStatus} from 'interfaces';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';

import {selectStripeConnectStatus} from '../digitalPracticeSelectors';
import {digitalPracticeActions} from '../digitalPracticeSlice';

import ProcessingFee from './ProcessingFee';

export const StripeOnboardingLink: FC = () => {
  const dispatch = useDispatch();
  const {t} = useTranslation();

  const user = useSelector(selectUserProfile) as ProviderProfile;
  const handleConnectionToStripeConnect = () => {
    if (user?.stripeAccountId && user?.stripeConnectOnboardingComplete) {
      window.open(
        'https://dashboard.stripe.com/login',
        '_blank',
        'noopener,noreferrer',
      );
    } else {
      dispatch(
        digitalPracticeActions.createStripeConnectAccount({role: user?.role}),
      );
    }
  };

  const stripeConnectStatus = useSelector(selectStripeConnectStatus);
  const isPreparingStripeConnectOnboardingLink =
    stripeConnectStatus === SliceStatus.pending;

  return (
    <>
      {isPreparingStripeConnectOnboardingLink ? (
        <div className="w-full flex items-center justify-between border rounded-lg h-14 px-5">
          <p className="text-lg text-gray-700">Loading, Please Wait...</p>
          <LoadingSpinner height={20} width={20} type="Oval" />
        </div>
      ) : (
        <button
          className="w-full flex items-center justify-between text-center text-lg  border rounded-lg h-14 px-5 hover:bg-blue-600/10 hover:border-transparent group"
          onClick={handleConnectionToStripeConnect}
        >
          <div className="flex items-center space-x-3">
            <StripeIcon classes="w-6 h-auto" />
            <p className="text-left">
              {user?.stripeAccountId && user?.stripeConnectOnboardingComplete
                ? t('providerProfileMenuItems.revenue.dp.goToStripe')
                : t('providerProfileMenuItems.revenue.dp.linkToStripe')}
            </p>
          </div>
          <GoForwardIcon
            fillColor="#315eff"
            strokeColor="text-blue-600"
            strokeWidth={0.3}
            classes="group-hover:animate-shake"
          />
        </button>
      )}

      <ProcessingFee
        countryCode={user?.countryOfResidence?.code}
        paymentService={PaymentService.STRIPE}
      />
    </>
  );
};

export default StripeOnboardingLink;
